import React, { useState, createContext } from "react";
export const UniversalContext = createContext();

export const UniversalContextProvider = props => {
    const [appointmentModal, setAppointmentModal] = useState(false);
    const [professionalModal, setProfessionalModal] = useState(false);
    const [contactUsModal, setContactUsModal] = useState(false);
    const [aboutUsModal, setAboutUsModal] = useState(false);
    const [alert, setAlert] = useState(false);

    return (
        <UniversalContext.Provider
            value={{
                appointmentModal, setAppointmentModal,
                professionalModal, setProfessionalModal,
                contactUsModal, setContactUsModal,
                aboutUsModal, setAboutUsModal,
                alert, setAlert
            }}
        >
            {props.children}
        </UniversalContext.Provider>
    );
}